/**
 * @generated SignedSource<<2e29ae45060dd8f22428e7c61448efb8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProblemDifficultyLevelEnum = "high" | "highest" | "low" | "lowest" | "medium" | "%future added value";
export type BookBookScrapDeleteDialog_bookScrapQuery$variables = {
  id: string;
};
export type BookBookScrapDeleteDialog_bookScrapQuery$data = {
  readonly bookScrap: {
    readonly difficultyLevel: ProblemDifficultyLevelEnum | null;
    readonly id: string;
    readonly problem: {
      readonly id: string;
      readonly objectUrl: string;
    };
    readonly problemBookPage: number;
    readonly problemNumber: string;
    readonly problemTex: string | null;
    readonly solution: {
      readonly id: string;
      readonly objectUrl: string;
    } | null;
    readonly solutionBookPage: number | null;
    readonly solutionTex: string | null;
    readonly unitD: {
      readonly id: string;
      readonly title: string;
      readonly unitATitle: string;
      readonly unitBTitle: string;
      readonly unitCTitle: string;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"BookScrapUpdateDialog_bookScrap">;
  };
};
export type BookBookScrapDeleteDialog_bookScrapQuery = {
  response: BookBookScrapDeleteDialog_bookScrapQuery$data;
  variables: BookBookScrapDeleteDialog_bookScrapQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "difficultyLevel",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "UnitD",
  "kind": "LinkedField",
  "name": "unitD",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unitATitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unitBTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unitCTitle",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "problemBookPage",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "solutionBookPage",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "problemNumber",
  "storageKey": null
},
v8 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "objectUrl",
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "problem",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "solution",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "problemTex",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "solutionTex",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookBookScrapDeleteDialog_bookScrapQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BookScrap",
        "kind": "LinkedField",
        "name": "bookScrap",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookScrapUpdateDialog_bookScrap"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookBookScrapDeleteDialog_bookScrapQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BookScrap",
        "kind": "LinkedField",
        "name": "bookScrap",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f2169520ad5a443bf56d07781518fdc3",
    "id": null,
    "metadata": {},
    "name": "BookBookScrapDeleteDialog_bookScrapQuery",
    "operationKind": "query",
    "text": "query BookBookScrapDeleteDialog_bookScrapQuery(\n  $id: ID!\n) {\n  bookScrap(id: $id) {\n    id\n    difficultyLevel\n    unitD {\n      id\n      title\n      unitATitle\n      unitBTitle\n      unitCTitle\n    }\n    problemBookPage\n    solutionBookPage\n    problemNumber\n    problem {\n      id\n      objectUrl\n    }\n    solution {\n      id\n      objectUrl\n    }\n    problemTex\n    solutionTex\n    ...BookScrapUpdateDialog_bookScrap\n  }\n}\n\nfragment BookScrapUpdateDialog_bookScrap on BookScrap {\n  id\n  unitD {\n    id\n  }\n  difficultyLevel\n  problemBookPage\n  problemNumber\n  problemTex\n  solutionBookPage\n  solutionTex\n}\n"
  }
};
})();

(node as any).hash = "d5e9e8a3291963e8c2b4421dbfc281c3";

export default node;
